import { ERRORS } from '../../constants/validations';

export function getReturnPolicyError({ channel, returnPolicyId }) {
  return !returnPolicyId && ERRORS.SHIPPING[channel].RETURN_POLICY;
}
